import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGraduationCap = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M22.207 9.16505V12.2888M22.207 9.16505L11.6035 13.3301L1 9.16505L11.6035 5L22.207 9.16505ZM17.4944 11.0171V16.4539C15.8882 17.7598 13.7966 18.5006 11.6145 18.5364C9.42661 18.4976 7.3292 17.7575 5.71267 16.4539V11.0171",
		stroke: "#8A94A6",
		strokeWidth: 1.6,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
const ForwardRef = forwardRef(SvgGraduationCap);
export { ForwardRef as ReactComponent };
